import {FlexContainer} from '../Atoms/Containers'
import {LinkButton} from '../Atoms/Buttons'
import React from 'react'
import {MemberCircleArrowRightIcon} from '../Atoms/Icons/MemberCircleArrowRightIcon'

export type LinkIconTextProps = {
  href?: string
  onClick?: () => void
  children: React.ReactNode
  dataTestId?: string
}

export const LinkIconText: React.VFC<LinkIconTextProps> = (props) => (
  <FlexContainer alignItems={'center'} justifyContent={'center'} gap={'5px'}>
    <MemberCircleArrowRightIcon/>
    <LinkButton data-testid={props.dataTestId} href={props.href} onClick={props.onClick}>
      {props.children}
    </LinkButton>
  </FlexContainer>
)
